import { extractTreeById } from './nested';
import { Component, NestedNode, WfFlatNode } from './schema';

/* These data- attributes are added to components in our library, for use by the blocks app */
export const BlocksDataAttribute = {
  NAME: 'blocks-name',
  SELF_SLOT: 'blocks-slot-self',
  CHILDREN_SLOT: 'blocks-slot-children',
  CANONICAL_ELEMENT: 'blocks-slot-item-canonical',
  NON_DELETABLE: 'blocks-non-deletable',
} as const;

const BLOCKS_DATA_ATTRIBUTES: string[] = Object.values(BlocksDataAttribute);

export function removeBlocksDataAttributes(component: Component) {
  const newNodes = component.payload.nodes.map((node) => {
    if (node.text) return node;
    if (!node.data.xattr || node.data.xattr.length === 0) return node;
    const xattr = node.data.xattr.filter((attr) => {
      return !BLOCKS_DATA_ATTRIBUTES.includes(attr.name);
    });
    return { ...node, data: { ...node.data, xattr } };
  });
  return { ...component, payload: { ...component.payload, nodes: newNodes } };
}

export function getDataAttr(
  node: NestedNode | WfFlatNode,
  name: string,
): string | undefined {
  if (node.text) return;
  return node.data.xattr?.find((attr) => attr.name === name)?.value;
}

export function getNodeName(node: NestedNode | WfFlatNode): string | undefined {
  return getDataAttr(node, BlocksDataAttribute.NAME);
}

export function extractTreeByName(
  component: Component,
  name: string | undefined,
): NestedNode {
  const { nodes } = component.payload;
  if (name == null) {
    if (nodes.length === 0) {
      throw new Error('Component has 0 nodes, can not get root');
    }
    return extractTreeById(nodes, nodes[0]._id);
  }
  const root = nodes.find((node) => getNodeName(node) === name);
  if (!root) {
    throw new Error(`Could not find root node with name ${name}`);
  }
  return extractTreeById(nodes, root._id);
}
